import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// UI
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      display: 'flex',
      flex: '1 1 auto',
    },
    row: {
      position: 'relative',
    },
    inputRoot: {
      alignItems: 'center',
    },
    inputAdornment: {
      display: 'flex',
      alignItems: 'center',
    },
  };
};

// Component
class SearchTextField extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
  };

  render() {
    let { classes, disabled, ...other } = this.props;

    return (
      <TextField
        disabled={disabled}
        InputProps={{
          classes: {
            root: classes.inputRoot,
          },
          startAdornment: (
            <InputAdornment position="start" className={classes.inputAdornment}>
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        {...other}
        data-cy="autocomplete-search-input"
      />
    );
  }
}

export default withStyles(styles)(SearchTextField);
